document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product__accordion details').forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      if (details.open) {
        // Closing: pin to current height, then animate to 0
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
          content.addEventListener('transitionend', () => {
            details.removeAttribute('open');
            content.style.maxHeight = '';
          }, { once: true });
        });
      } else {
        // Opening: add [open] so content enters DOM, start at 0, animate to real height
        content.style.maxHeight = '0px';
        details.setAttribute('open', '');
        requestAnimationFrame(() => {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.addEventListener('transitionend', () => {
            content.style.maxHeight = '';
          }, { once: true });
        });
      }
    });
  });
});
